{
  "title": "Activity Recap",
  "recapAsOf": "As of",
  "asOfLast48Hours": "Last 48 hours",
  "viewActivity": "View full log →",
  "empty": "No batch activity in the last 2 business days",
  "filterNoResults": "No events match this filter",
  "errorPrefix": "Error:",
  "summary": {
    "batchesRunDescription": "Across 2 business days",
    "tradesSentDescription": "Submitted to custodians",
    "portfoliosRebalancedDescription": "Across all custodians",
    "failedOrCanceledDescription": "Require review"
  },
  "events": {
    "portfoliosOptimized_one": "{{count}} portfolio optimized",
    "portfoliosOptimized_other": "{{count}} portfolios optimized",
    "bulkTradeRunState": "Bulk trade run {{state}}"
  },
  "metrics": {
    "trades_one": "trade",
    "trades_other": "trades",
    "portfolios_one": "portfolio",
    "portfolios_other": "portfolios"
  },
  "cards": {
    "batchesRun": {
      "title": "BATCHES RUN"
    },
    "tradesSent": {
      "title": "TRADES SENT"
    },
    "portfoliosRebalanced": {
      "title": "PORTFOLIOS REBALANCED"
    },
    "failedOrCanceled": {
      "title": "FAILED / CANCELED"
    }
  },
  "eventLog": {
    "sectionTitle": "EVENT LOG",
    "columns": {
      "type": "Type",
      "description": "Description",
      "metrics": "Metrics",
      "status": "Status",
      "time": "Time"
    }
  },
  "filters": {
    "all": "All",
    "completed": "Completed",
    "tradesSent": "Trades sent",
    "failedOrCanceled": "Failed / canceled"
  },
  "status": {
    "COMPLETED": "Completed",
    "SENT": "Sent",
    "FAILED": "Failed",
    "CANCELED": "Canceled"
  }
}
